import { TipoMovimentacao } from './tipo-movimentacao';
import { CadastroBem } from './cadastro-bem';
export class Movimentacao {
  cD_BPM_MOVIMENTACAO_PATRIMONIAL: number;
  nR_BPM_BEM_PATRIMONIAL: number;
  cD_BPM_TIPO_MOVIMENTACAO_PATRIMONIAL: number;
  cD_CDU_MATRICULA_ORIGEM: number;
  cD_CDU_MATRICULA_DESTINO: number;
  cD_CDU_MATRICULA_GESTOR: number;
  dT_DATA_MOVIMENTACAO_PATRIMONIAL: Date;
  cD_BPM_UNIDADE_OP_ANTERIOR: number;
  cD_BPM_UNIDADE_OP_POSTERIOR: number;
  dS_BPM_SALA_POSTERIOR: string;
  dS_BPM_SALA_ANTERIOR: string;
  fL_BPM_ATIVO: number;
  fL_BPM_DELETADO: number;
  dS_NM_ORIGEM: string;
  dS_NM_DESTINO: string;
  dS_NM_GESTOR: string;
  dS_BPM_TIPO_MOVIMENTACAO_PATRIMONIAL: string;
  dS_BPM_DESCRICAO_BEM: string;
  dS_BPM_TEXTO_EVIDENCIA: string;
  cD_BPM_ARQUIVO_PATRIMONIAL: number;
  dS_BPM_FILENAME_ARQUIVO_PATRIMONIAL: string;
  cD_CDU_MATRICULA_AUTOR: number;
  dS_NM_AUTOR: string;
  dS_BPM_ETIQUETA_BEM: string;
}
